import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-poh-keyno-top-status',
  templateUrl: './poh-keyno-top-status.component.html',
  styleUrls: ['./poh-keyno-top-status.component.css']
})
export class PohKeynoTopStatusComponent implements OnInit {
    public pohKeynoTop: string;

    public selectedBgPohTop: string = 'D';

    public menu?: Menu;

    public itemsListPohTops: Item[] = [];

    public itemsListStatuses: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.pohKeynoTop = this.stateService.getStateParams()['poh_keyno_top'];
    }

    private async loadMenu() {
        if (!!this.pohKeynoTop) {
            this.menu = (await this.datatask.Post(395, { poh_keyno_top: this.pohKeynoTop }))[0];
        }
    }

    private async loadPohTops() {
        if(!!this.pohKeynoTop) {
            this.itemsListPohTops = await this.datatask.Post(396, { poh_keyno_top: this.pohKeynoTop });
        }
    }

    private async loadStatuses() {
        if (!this.menu) return;

        return this.itemsListStatuses = await this.datatask.Post(406, { order_internal_no: this.menu.order_internal_no });
    }

    private async init() {
        await this.loadMenu();
        this.loadPohTops();
        this.loadStatuses();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    order_order_no: string;
    custname: string;
    deliverydate_confirmed: string;
    order_internal_no: string;
}
